import React, { useRef } from "react";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPen, faBackspace, faPaperclip, faXmark, faDownload } from "@fortawesome/free-solid-svg-icons";

import SelectControl from "../SelecControl/SelectControl";
import { opcionesActStatus } from "../../utils/estructuras";

const RRLogsFServ = ({l, i, handleChange, handleDelete, usuario, opcionesUsers, fServChecked, lastElement, modo, archivoLog, onFileChange}) => {

    const fileInputRef = useRef(null);

    const handleFileSelect = (e) => {
        const file = e.target.files[0];
        if(file) onFileChange(i, l.rowKey, file);
        e.target.value = '';
    };

    const handleFileRemove = () => {
        onFileChange(i, l.rowKey, null);
    };

    const getDisplayName = () => {
        if(archivoLog?.file) return archivoLog.file.name;
        if(archivoLog?.existingName) {
            const parts = archivoLog.existingName.split('_');
            return parts.length > 1 ? parts.slice(1).join('_') : archivoLog.existingName;
        }
        return null;
    };
    const fileName = getDisplayName();
    const eventoSelected = !!l.evento?.value;

    return <div className="rrLogsFServDiv">
        {modo != 'Vista' && <FontAwesomeIcon icon={faBackspace} color="red" style={{ width: '5%', height: '40px', marginTop: "5px", cursor: "pointer" }} onClick={()=>handleDelete(l,i)}/>}
        <input className="fechaInput" disabled={modo == 'Vista'} name="fecha" value={l.fecha} type="datetime-local" onChange={(e) => handleChange({}, i , e.target.name, e.target.value)}/>
        <SelectControl modo={modo} tipo={'logsFServ'} propToChange="evento" optionsSelect={opcionesActStatus} handleChengeSelect={handleChange} index={i} valueSeleccionada={l.evento} placeholder={"Seleccione evento..."}/>
        <input className="textAdicInput" disabled={modo == 'Vista'} name="textAdic" value={l.textAdic} onChange={(e) => handleChange({}, i, e.target.name, e.target.value)} placeholder="Ingrese texto adicional"/>
        <SelectControl modo={modo} tipo={'logsFServ'} optionsSelect={opcionesUsers} handleChengeSelect={handleChange} index={i} valueSeleccionada={l.user} propToChange="user" placeholder={"Seleccione usuario..."}/>
        <div className="archivoLogCell">
            {modo != 'Vista' && !fileName && <div style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                <input type="file" ref={fileInputRef} onChange={handleFileSelect} disabled={!eventoSelected} style={{display:'none'}} accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.ppt,.pptx,.txt,.rtf,.odt,.ods,.odp,.jpg,.jpeg,.png,.gif,.bmp,.webp,.svg,.tiff,.mp4,.avi,.mov,.mkv,.mp3,.wav,.zip,.rar,.7z"/>
                <div style={{ cursor: eventoSelected ? 'pointer' : 'not-allowed', opacity: eventoSelected ? 1 : 0.5 }} onClick={() => { if(eventoSelected) fileInputRef.current?.click(); }} title={eventoSelected ? 'Adjuntar archivo' : 'Seleccioná un evento primero'}>
                    <label style={{ cursor: 'inherit' }}>Adjuntar archivo</label>
                    <FontAwesomeIcon icon={faPaperclip} className="attachIcon" title={eventoSelected ? 'Adjuntar archivo' : 'Seleccioná un evento primero'}/>
                </div>
            </div>}
            {fileName && <div className="archivoLogInfo" style={{width:'100%', height:'100%', display:'flex', alignItems:'center', justifyContent:'center'}}>
                <span className="archivoLogName" title={fileName}>{fileName.length > 18 ? fileName.substring(0,18) + '...' : fileName}</span>
                {archivoLog?.url && <a href={archivoLog.url} download={fileName} target="_blank" rel="noopener noreferrer">
                    <FontAwesomeIcon icon={faDownload} className="downloadFileIcon" title="Descargar archivo"/>
                </a>}
                {modo != 'Vista' && <FontAwesomeIcon icon={faXmark} className="removeFileIcon" onClick={handleFileRemove} title="Quitar archivo"/>}
            </div>}
        </div>
    </div>
}

export default RRLogsFServ;
